import { getDocument } from '@app/store/document/selectors';
import { RootState } from '@app/store/types';

// eslint-disable-next-line import/prefer-default-export
export const getAuditTrailFile = (state: RootState) => getDocument(state).auditTrailFile;
